export default __webpack_public_path__ + "static/media/assign-column-inactive.f25189b8.svg";